export const WEEKLY = 'WEEKLY'
export const MONTHLY = 'MONTHLY'

export default () => [
    { value: WEEKLY, label: 'Weekly' },
    { value: MONTHLY, label: 'Monthly' },
]
